import { Edit, DeleteOutline } from '@mui/icons-material';
import styled from '@emotion/styled';
import { settingsTheme as t } from '../../theme';

interface RowActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  editLabel: string;
  deleteLabel: string;
}

const Row = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 4,
});

const IconButton = styled.button<{ hoverColor: string; hoverBg: string }>(({ hoverColor, hoverBg }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  background: 'transparent',
  color: t.color.muted,
  cursor: 'pointer',
  padding: 6,
  borderRadius: t.radius.xs,
  transition: 'color 0.15s ease, background 0.15s ease',
  '& .MuiSvgIcon-root': { fontSize: 20 },
  '&:hover': { color: hoverColor, background: hoverBg },
}));

/**
 * Molécula: acciones por fila (editar y eliminar) con realce contextual.
 */
const RowActions = ({ onEdit, onDelete, editLabel, deleteLabel }: RowActionsProps) => (
  <Row>
    <IconButton type="button" onClick={onEdit} aria-label={editLabel} hoverColor={t.color.primary} hoverBg={t.color.countBg}>
      <Edit />
    </IconButton>
    <IconButton
      type="button"
      onClick={onDelete}
      aria-label={deleteLabel}
      hoverColor={t.color.danger}
      hoverBg={t.color.dangerSurface}
    >
      <DeleteOutline />
    </IconButton>
  </Row>
);

export default RowActions;
